import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import pdfLogo from '../../../../assets/images/pdf-icon-4.png';
import MyDocument from '../../../../components/PdfGenerator/MyDocument';
import ImageAsBase64 from '../../../../utils/imageToBase64';
import { pdf } from '@react-pdf/renderer';
import CudelLogo from '../../../../assets/images/cudel_logo.png';
import AuthorizedSignature from '../../../../assets/images/authorized_signature.png';
import Swal from 'sweetalert2';


const GeneratePdf = ({ invoiceData, taxBreakup, totals }) => {
  const [logoData, setLogoData] = useState(null);
  const [signatureData, setSignatureData] = useState(null);
  // Load logo on component mount
  useEffect(() => {
    const loadLogo = async (image) => {
      try {
        if (image == "logo") {
          const base64 = await ImageAsBase64(CudelLogo);
          setLogoData(base64);
        } else if (image == "signature") {
          const base64 = await ImageAsBase64(AuthorizedSignature);
          setSignatureData(base64);
        }
      } catch (error) {
        console.error("Error loading logo:", error);
      }
    };

    loadLogo("logo");
    loadLogo("signature");
  }, []);

  const handleOpenInNewTab = async () => {
    // Show loading message
    Swal.fire({
      title: 'Generating PDF',
      text: 'Please wait while the PDF is being generated...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const blob = await pdf(
        <MyDocument
          data={invoiceData}
          logoData={logoData}
          signatureData={signatureData}
          taxBreakup={taxBreakup}
          totals={totals}
        />
      ).toBlob();

      // Close the loading message
      Swal.close();

      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, "_blank");
    } catch (error) {
      // Handle error and close the loading message
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to generate PDF. Please try again.',
      });
      console.error("Error generating PDF:", error);
    }
  };
  // const handleOpenInNewTab = async () => {
  //   const blob = await pdf(
  //     <MyDocument
  //       data={invoiceData}
  //       logoData={logoData}
  //       signatureData={signatureData}
  //       taxBreakup={taxBreakup}
  //       totals={totals}
  //     />
  //   ).toBlob();
  //   const blobUrl = URL.createObjectURL(blob);
  //   window.open(blobUrl, "_blank");
  // };
  return (
    <Box sx={{ cursor: 'pointer', width: 'fit-content' }}
      onClick={() => handleOpenInNewTab()}
    >
      <img
        src={pdfLogo}
        alt='download_pdf_logo'
        style={{ width: '50px', height: '50px' }}
      />
    </Box>
  );
}

export default GeneratePdf;
